import { I18nContext } from "components/I18N";
import { useContext } from "react";

const ProductBox = ({ id }) => {
  const { I18n, langCode } = useContext(I18nContext);
  I18n.setLanguage(langCode);

  const data = {
    1: {
      tag: I18n.get("erectileDysfunction"),
      image: "/images/homepage/product1.png",
      name: I18n.get("treatmentEDPageBluePillName"),
      icon: "/images/homepage/pill1.png",
      desc: I18n.get("treatmentEDPageBluePillDesc"),
    },
    2: {
      tag: I18n.get("erectileDysfunction"),
      image: "/images/homepage/product2.png",
      name: I18n.get("treatmentEDPageYellowPillName"),
      icon: "/icons/yellow-pill.svg",
      desc: I18n.get("treatmentEDPageYellowPillDesc"),
    },
    3: {
      tag: I18n.get("prematureEjaculation"),
      image: "/images/treatment/product3.png",
      name: I18n.get("treatmentPEPageBluePillName"),
      icon: "/icons/light-blue-pill.svg",
      desc: I18n.get("treatmentPEPageBluePillDesc"),
    },
    4: {
      tag: I18n.get("homePageHairItem"),
      image: "/images/treatment/product4.png",
      name: I18n.get("treatmentHLPageDropperName"),
      icon: "/icons/dropper-icon.svg",
      desc: I18n.get("treatmentHLPageDropperDesc"),
    },
    5: {
      tag: I18n.get("homePageHairItem"),
      image: "/images/treatment/product5.png",
      name: I18n.get("treatmentHLPagePinkPillName"),
      icon: "/icons/pink-pill.svg",
      desc: I18n.get("treatmentHLPagePinkPillDesc"),
    },
  };

  return (
    <div className="flex-1 min-w-[280px] lg:max-w-[384px] h-full">
      <div className="pill-detail-box bg-white h-full">
        <div className="relative mb-[20px] lg:mb-[30px] w-full">
          <div className="absolute top-[12px] left-[12px] lg:top-[16px] lg:left-[16px] bg-white px-[16px] py-[4] rounded-[4px]">
            <p className="text-[12px] leading-[20px] font-semibold">
              {data[id].tag}
            </p>
          </div>
          <img
            alt="product"
            src={data[id].image}
            className="w-full h-[165px] lg:h-[260px] rounded-[8px] object-cover"
          />
        </div>
        <div className="flex space-x-[8px]">
          <img
            alt="product"
            src={data[id].icon}
            className="h-[30px] w-auto object-contain"
          />
          <h3 className="font-bold">{data[id].name}</h3>
        </div>
        <div
          className="flex flex-col gap-2 pb-[36px]"
          dangerouslySetInnerHTML={{ __html: data[id].desc }}
        />
      </div>
    </div>
  );
};

export default ProductBox;
